import { FormControlLabel } from '@mui/material'
import TextareaAutosize from 'components/common/Textarea/TextareaAutosize'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const ItemFormTextarea = ({
    autoFocus = false,
    label,
    labelKey,
    name,
    required = false,
    rules,
    ...props
}) => {
    const { t } = useTranslation()
    const { register, setValue, watch, formState: { errors } } = useFormContext()
    const {
        minRows = 2,
        maxRows = 6,
        labelPlacement = "top",
        disabled,
        readOnly = false,
        trimOnBlur = true,
        ...textareaProps
    } = props

    const error = errors?.[name]
    const fieldRegister = register(name, rules)

    return (
        <FormControlLabel
            label={labelKey ? t(labelKey) : label}
            labelPlacement={labelPlacement}
            sx={{
                alignItems: 'stretch',
                m: 0,
                width: '100%',
                '& .MuiFormControlLabel-label': {
                    pt: '4px'
                }
            }}
            control={
                <TextareaAutosize
                    {...fieldRegister}
                    {...textareaProps}
                    required={required}
                    autoFocus={autoFocus}
                    minRows={minRows}
                    maxRows={maxRows}
                    disabled={disabled}
                    readOnly={readOnly}
                    error={!!error}
                    fullWidth
                    helperText={error ? t(error.message) : ''}
                    onBlur={(e) => {
                        fieldRegister.onBlur(e)
                        textareaProps.onBlur?.(e)
                        if (trimOnBlur) {
                            setValue(name, watch(name)?.trim())
                        }
                    }}
                    onChange={(e) => {
                        fieldRegister.onChange(e)
                        textareaProps.onChange?.(e)
                    }}
                    clearInput={watch(name)}
                    onClearInput={() =>
                        setValue(name, '', {
                            shouldValidate: true,
                            shouldDirty: true
                        })
                    }
                />
            }
        />
    )
}

export default ItemFormTextarea
